import { Group } from '@mantine/core';
import type { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Radio } from '../../../../ui-library/radio/radio';
import { MetricType } from '../../process-analysis.type';

type Props = {
  value: MetricType;
  onChange: (value: MetricType) => void;
};

export const MetricSwitcher = ({ value, onChange }: Props) => {
  const i18n = useTranslation();
  const handleWorkUnitsChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      onChange(MetricType.WorkUnits);
    }
  };

  const handlePointsChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      onChange(MetricType.Points);
    }
  };

  return (
    <Group>
      <Radio
        checked={value === MetricType.WorkUnits}
        onChange={handleWorkUnitsChange}
        label={i18n.t('common.work_units')}
      />
      <Radio checked={value === MetricType.Points} onChange={handlePointsChange} label={i18n.t('common.estimation')} />
    </Group>
  );
};
